<template>
  <section v-if="categories && categories.length > 0" id="shop-summary" class="shop-section bg-black py-5">
    <div class="container-fluid px-md-5">
      <div class="row mb-5 align-items-end" data-aos="fade-left">
        <!-- <div class="col-md-8">
          <span class="text-danger fw-bold letter-spacing-5">EQUIPAMIENTO</span>
          <h2 class="display-3 fw-900 text-white m-0">EQUIPO PROBADO EN CAMPO</h2>
        </div> -->

        <div class="col-lg-7">
          <!-- <span class="text-danger fw-bold letter-spacing-5">EQUIPAMIENTO</span> -->
          <h2 class="display-2 fw-900 text-white mb-0 letter-spacing-tight">Equipo<br><span
              class="text-danger">Probado en campo</span></h2>
        </div>
        <div class="col-md-4 text-md-end">
          <RouterLink to="/shop" class="btn-link-tactic">
            EXPLORAR TODO EL CATÁLOGO <i class="bi bi-chevron-right"></i>
          </RouterLink>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-lg-7" data-aos="zoom-in">
          <RouterLink :to="categories[0]?.link || '/shop'" class="shop-anchor">
            <div class="bento-item big">
              <div 
                class="bento-bg" 
                :style="{ backgroundImage: `url(${categories[0]?.image})` }"
              ></div>
              <div class="bento-overlay"></div>
              <div class="bento-content">
                <span class="category-number">01</span>
                <h3 class="bento-title">{{ categories[0]?.name }}</h3>
                <p class="bento-desc">
                  Diseñado para el movimiento. Construido para durar.
                </p>
              </div>
            </div>
          </RouterLink>
        </div>

        <div class="col-lg-5">
          <div class="row g-3">
            <div 
              class="col-12" 
              v-for="(cat, index) in categories.slice(1)" 
              :key="index" 
              data-aos="fade-up" 
              :data-aos-delay="index * 200"
            >
              <RouterLink :to="cat.link" class="shop-anchor">
                <div class="bento-item small">
                  <div class="bento-bg" :style="{ backgroundImage: `url(${cat.image})` }"></div>
                  <div class="bento-overlay"></div>
                  <div class="bento-content">
                    <span class="category-number">0{{ index + 2 }}</span>
                    <h3 class="bento-title small">{{ cat.name }}</h3>
                  </div>
                </div>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

// Importación de las imágenes tácticas
import apparelImg from "@/assets/img/Tactical/tactical_11.jpg";
import gearImg from "@/assets/img/Tactical/tactical_05.jpg";
import accessoriesImg from "@/assets/img/Tactical/tactical_09.jpg";

const categories = ref([
  {
    name: "ROPA",
    link: "/shop",
    image: apparelImg
  },
  {
    name: "EQUIPO",
    link: "/shop",
    image: gearImg
  },
  {
    name: "ACCESORIOS",
    link: "/shop",
    image: accessoriesImg
  }
]);

</script>

<style scoped>
.shop-section {
  overflow: hidden;
  background: #050505;
  border-top: 4px solid #ff3131;
}



.fw-900 { font-weight: 900; }
.letter-spacing-5 { letter-spacing: 5px; font-size: 0.8rem; }

/* Estilo del Link de exploración */
.btn-link-tactic {
  color: #ff3131;
  text-decoration: none;
  font-weight: 800;
  font-size: 0.9rem;
  transition: 0.3s;
}
.btn-link-tactic:hover { letter-spacing: 2px; color: #fff; }

/* Bento Grid System */
.shop-anchor { text-decoration: none; color: inherit; }

.bento-item {
  position: relative;
  overflow: hidden;
  background: #111;
  display: flex;
  align-items: flex-end;
  padding: 40px;
  transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #222;
}

.bento-item.big { height: 600px; }
.bento-item.small { height: 292px; }

.bento-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: grayscale(100%) brightness(0.6);
  transition: 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.bento-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(0deg, rgba(255,49,49,0.4) 0%, transparent 60%);
  opacity: 0;
  transition: 0.5s;
  z-index: 2;
}

.bento-content {
  position: relative;
  z-index: 3;
  transform: translateY(20px);
  transition: 0.5s;
}

.category-number {
  color: #ff3131;
  font-family: 'Courier New', Courier, monospace;
  font-weight: 900;
  font-size: 1.5rem;
  display: block;
  margin-bottom: 10px;
}

.bento-title {
  color: #fff;
  font-size: 4rem;
  font-weight: 900;
  margin: 0;
  line-height: 0.9;
  text-transform: uppercase;
}

.bento-title.small { font-size: 2.5rem; }

.bento-desc {
  color: #ccc;
  font-size: 0.9rem;
  max-width: 300px;
  margin-top: 15px;
  opacity: 0;
  transition: 0.5s;
}

/* Hover States */
.bento-item:hover {
  border-color: #ff3131;
}

.bento-item:hover .bento-bg {
  filter: grayscale(0%) brightness(0.8);
  transform: scale(1.1);
}

.bento-item:hover .bento-overlay {
  opacity: 1;
}

.bento-item:hover .bento-content {
  transform: translateY(0);
}

.bento-item:hover .bento-desc {
  opacity: 1;
}

@media (max-width: 991px) {
  .bento-item.big, .bento-item.small { height: 400px; }
  .bento-title { font-size: 2.5rem; }
}
</style>